'use client';

import { Button } from '@ahafood/ui/components/button';
import { ArrowUp } from 'lucide-react';
import { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Button
      className="fixed bottom-4 right-4 rounded-full p-2 size-12 shadow-sm [&_svg]:size-6"
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <ArrowUp className="size-6" />
    </Button>
  );
};

export default ScrollToTopButton;
